const Type = ({ color = "var(--grey400)" }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.27215 8.68065V9.154C5.27215 10.0021 5.43741 10.5806 5.76793 10.8896C6.09845 11.1921 6.72082 11.3433 7.63502 11.3433H9.36498C10.0823 11.3433 10.6132 11.2808 10.9578 11.1559C11.3024 11.031 11.5309 10.8107 11.6435 10.4952C11.7208 10.2453 11.8263 10.0547 11.9599 9.9232C12.1006 9.79171 12.3115 9.72597 12.5928 9.72597C12.8882 9.72597 13.1132 9.79829 13.2679 9.94292C13.4226 10.0876 13.4719 10.2979 13.4156 10.5741C13.2609 11.3893 12.846 11.9974 12.1709 12.3984C11.4958 12.7995 10.5605 13 9.36498 13H7.63502C6.23558 13 5.1948 12.6844 4.51266 12.0533C3.83755 11.4222 3.5 10.4557 3.5 9.154V6.86613C3.5 5.53153 3.83755 4.55195 4.51266 3.92739C5.1948 3.29625 6.23558 2.98725 7.63502 3.0004H9.36498C10.7714 3.0004 11.8122 3.31597 12.4873 3.94711C13.1624 4.57167 13.5 5.54468 13.5 6.86613V7.85228C13.5 8.40452 13.2046 8.68065 12.6139 8.68065H5.27215ZM7.63502 4.65714C6.72082 4.64399 6.09845 4.79191 5.76793 5.10091C5.43741 5.4099 5.27215 5.99831 5.27215 6.86613V7.02391H11.7278V6.86613C11.7278 6.00488 11.5626 5.42305 11.2321 5.12063C10.9086 4.81164 10.2862 4.65714 9.36498 4.65714H7.63502Z"
        fill={color}
      />
    </svg>
  );
};

export default Type;
